import { Tooltip } from "@mui/material";
import React, { ReactElement } from "react";

import { Graphic } from "../../generated/gql/graphql";
import { classNames } from "../../utils/classes";

type Props = {
  gridSize: number;
  onClick: (id: string) => void;
  displayType: "full" | "auto";

  graphic: Pick<Graphic, "id" | "name"> & {
    asset: Pick<Graphic["asset"], "thumbnailUrl">;
  };
};

export default function GraphicListItem(props: Props): ReactElement {
  const { graphic, onClick, displayType, gridSize } = props;
  const { id, name, asset } = graphic;

  return (
    <div
      style={{ width: `${gridSize}px` }}
      key={id}
      className="inline-block cursor-pointer break-all"
    >
      <button
        type="button"
        className="flex max-w-full flex-col space-y-2"
        onClick={() => onClick(id)}
      >
        <img
          src={asset.thumbnailUrl}
          alt={`${name} thumbnail`}
          style={{
            width: displayType === "full" ? "100%" : "auto",
            aspectRatio: "1/1",
          }}
          className={classNames("rounded object-contain")}
        />
        <Tooltip title={name} placement="bottom" arrow>
          <p className="max-w-full truncate text-sm text-gray-500">{name}</p>
        </Tooltip>
      </button>
    </div>
  );
}
